<template>
  <section class="pb-empty" :aria-labelledby="id">
    <span class="pb-empty-icon" aria-hidden="true"><i :class="['mdi', icon]"></i></span>
    <h2 :id="id" class="display-font">{{ title }}</h2>
    <p v-if="text">{{ text }}</p>
    <div v-if="$slots.default" class="pb-actions"><slot /></div>
  </section>
</template>

<script>
let counter = 0;
export default {
  name: 'EmptyState',
  props: {
    icon: { type: String, default: 'mdi-comment-quote-outline' },
    title: { type: String, required: true },
    text: { type: String, default: '' }
  },
  data() { counter += 1; return { id: 'empty-' + counter }; }
};
</script>
